// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"81":"policy6","85":"policy4","443":"about","658":"policy10","916":"policy8"}[chunkId] + "." + {"81":"6e2a82c3","85":"e7ca030a","443":"1975b903","658":"3fe0d31a","916":"5661335f"}[chunkId] + ".js";
};